export default "__VITE_ASSET__2a3c8fef__"